export enum EProjectsActionType {
  GET_PROJECTS_RECURSIVELY = 'PROJECTS/GET_RECURSIVELY',
  LOADING_PROJECTS_RECURSIVELY = 'PROJECTS/LOADING_RECURSIVELY',
  SET_PROJECTS_RECURSIVELY = 'PROJECTS/SET_RECURSIVELY',
  LOADING_PROJECTS_RECURSIVELY_FAILED = 'PROJECTS/LOADING_RECURSIVELY_FAILED',
}
